import {IUploadFileFormBaseValues} from 'admin/resources/upload';
import {ResourceTypeNumEnum} from 'admin/resources/enums';
import {IWithDisabled} from 'models/common';
import React, {FC} from 'react';
import {useFormikContext} from 'formik';
import {makeStyles} from '@material-ui/core';
import {Container, Label, Text} from 'components-lib';

type Props = IWithDisabled;

const fileTypeDisplayNames: Record<number, string> = {
  [ResourceTypeNumEnum.Video]: 'Video',
  [ResourceTypeNumEnum.Audio]: 'Audio',
  [ResourceTypeNumEnum.Image]: 'Image',
  [ResourceTypeNumEnum.Document]: 'Document',
  [ResourceTypeNumEnum.PDF]: 'PDF',
  [ResourceTypeNumEnum.FillablePDF]: 'Fillable PDF',
  [ResourceTypeNumEnum.Other]: 'Other',
  [ResourceTypeNumEnum.ScormPackage]: 'SCORM Package',
  [ResourceTypeNumEnum.WebLink]: 'Web Link',
  [ResourceTypeNumEnum.K12Resource]: 'K12 Resource',
  [ResourceTypeNumEnum.Excel]: 'Excel',
  [ResourceTypeNumEnum.Archive]: 'Archive',
};

export const AssetIdLabel: FC<Props> = () => {
  const classes = useStyles();
  const {values} = useFormikContext<IUploadFileFormBaseValues>();
  const assetId = values?.id;

  return (
    <Container disableGutters classes={{root: classes.root}}>
      <Label label="Asset ID" withLeftMargin={false} withFontBold withMarginBottom={false} />
      <Text.Paragraph className={classes.value}>{assetId || '—'}</Text.Paragraph>
    </Container>
  );
};

export const FileNameLabel: FC<Props> = () => {
  const classes = useStyles();
  const {values} = useFormikContext<IUploadFileFormBaseValues>();
  const fileName = values?.fileName || values?.file?.name;

  return (
    <Container disableGutters classes={{root: classes.root}}>
      <Label label="File Name" withLeftMargin={false} withFontBold withMarginBottom={false} />
      <Text.Paragraph className={classes.value}>{fileName || '—'}</Text.Paragraph>
    </Container>
  );
};

export const FileTypeLabel: FC<Props> = () => {
  const classes = useStyles();
  const {values} = useFormikContext<IUploadFileFormBaseValues>();
  const fileType = values?.fileType;
  const fileTypeName =
    fileType === null || fileType === undefined ? '' : fileTypeDisplayNames[fileType] || String(fileType);

  return (
    <Container disableGutters classes={{root: classes.root}}>
      <Label label="File Type" withLeftMargin={false} withFontBold withMarginBottom={false} />
      <Text.Paragraph className={classes.value}>{fileTypeName || '—'}</Text.Paragraph>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  value: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
  },
}));
